import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminLayout } from '@/layout/AdminLayout';
import { Dashboard } from '@/pages/Dashboard';
import { VendorList } from '@/pages/vendors/VendorList';
import { VendorDetail } from '@/pages/vendors/VendorDetail';
import { VendorVerification } from '@/pages/vendors/VendorVerification';
import { CustomerList } from '@/pages/customers/CustomerList';
import { CustomerDetail } from '@/pages/customers/CustomerDetail';
import { ProductList } from '@/pages/ProductList';
import { ProductCreate } from '@/pages/products/ProductCreate';
import { ProductDetail } from '@/pages/products/ProductDetail';
import { OrderList } from '@/pages/orders/OrderList';
import { OrderDetail } from '@/pages/orders/OrderDetail';
import { StaffList } from '@/pages/staff/StaffList';
import { CategoryList } from '@/pages/categories/CategoryList';
import { Payments } from '@/pages/Payments';
import { Analytics } from '@/pages/Analytics';
import { Settings } from '@/pages/Settings';
import { Roadblockers } from '@/pages/Roadblockers';
import { SystemLogs } from '@/pages/SystemLogs';
import { Login } from '@/pages/Login';
import { NotFound } from '@/pages/NotFound';
import { HomepageCms } from '@/pages/content/HomepageCms';
import { TeamCms } from '@/pages/content/TeamCms';
import { PartnersCms } from '@/pages/content/PartnersCms';
import { FestivalCms } from '@/pages/content/FestivalCms';
import { HeroCms } from '@/pages/content/HeroCms';
import { FooterCms } from '@/pages/content/FooterCms';
import { InfoPagesCms } from '@/pages/content/InfoPagesCms';
import { ProtectedRoute } from '@/components/shared/ProtectedRoute';
import { applyTheme, loadTheme } from '@/lib/theme';

export default function App() {
  useEffect(() => {
    applyTheme(loadTheme());
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />

          {/* Vendors */}
          <Route path="vendors" element={<VendorList />} />
          <Route path="vendors/:id" element={<VendorDetail />} />
          <Route path="vendors/:id/verify" element={<VendorVerification />} />

          {/* Customers */}
          <Route path="users" element={<CustomerList />} />
          <Route path="users/:id" element={<CustomerDetail />} />

          {/* Catalog */}
          <Route path="products" element={<ProductList />} />
          <Route path="products/new" element={<ProductCreate />} />
          <Route path="products/:id" element={<ProductDetail />} />
          <Route path="categories" element={<CategoryList />} />

          {/* Orders */}
          <Route path="orders" element={<OrderList />} />
          <Route path="orders/:id" element={<OrderDetail />} />

          {/* Staff (super_admin) */}
          <Route path="staff" element={<StaffList />} />

          {/* Payments */}
          <Route path="payments" element={<Payments />} />

          {/* Analytics */}
          <Route path="analytics" element={<Analytics />} />

          {/* Marketing */}
          <Route path="roadblockers" element={<Roadblockers />} />
          <Route path="content/homepage" element={<HomepageCms />} />
          <Route path="content/hero" element={<HeroCms />} />
          <Route path="content/festival" element={<FestivalCms />} />
          <Route path="content/footer" element={<FooterCms />} />
          <Route path="content/info-pages" element={<InfoPagesCms />} />
          <Route path="content/team" element={<TeamCms />} />
          <Route path="content/partners" element={<PartnersCms />} />

          {/* Settings */}
          <Route path="settings" element={<Settings />} />

          {/* System — super_admin only */}
          <Route path="system/logs" element={<SystemLogs />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
